import {ButtonBase, Button, styled } from "@mui/material";

const SecondaryButton = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: "1rem",
    padding: ".75rem",
    border: '1px solid',
    lineHeight: 1,
    backgroundColor: '#f2f2f2',
    borderColor: '#b3b3b3',
    color: "#000000",
    opacity: "1",
    fontWeight: "normal",
    toUpperCase: "uppercase",
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#dfdfdf',
      borderColor: '#b3b3b3',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#000000',
      borderColor: '#005cbf',
      color: "#ffffff"
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });


  export default SecondaryButton;